import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=0dd9e5f8&scoped=true&"
import script from "./CardTable.vue?vue&type=script&lang=js&"
export * from "./CardTable.vue?vue&type=script&lang=js&"
import style0 from "./CardTable.vue?vue&type=style&index=0&id=0dd9e5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd9e5f8",
  null
  
)

export default component.exports